import { INITIALIZE_FORM_INSTALLER_DATA } from '../actionTypes';
import { installerProfileActions } from '../reducer';

export default (values) =>
    installerProfileActions[INITIALIZE_FORM_INSTALLER_DATA](values);
